import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { User } from './user';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';



@Injectable()
export class AuthService {

  authState: any = null;
  username_value: any;
  client: any;
  roleuser: any;
  loggedInUserName: any;
  loggedInUserRole: any;
  loggedInUserClient: any;
  editUser_ID: string;
  editUserID = this.editUser_ID
  editUser_newEmail: any;
  editUser_username: any;
  editUser_client: any;
  editUser_role: any;
  logout: boolean = false;
  loggedInUserData: any;


  monthly_quota:number;
  used_quota: number;

  constructor(private afAuth: AngularFireAuth, private router: Router, private afs: AngularFirestore) {
    this.afAuth.authState.subscribe((auth) => {
      this.authState = auth
    });
  }

  private loggedIn = new BehaviorSubject<boolean>(false); // {1}

  get isLoggedIn() {
    return this.loggedIn.asObservable(); // {2}
  }

  login(user: User){
    if (user.userName !== '' && user.password != '' ) { // {3}
      this.loggedIn.next(true);
      this.router.navigate(['/']);
    }
  }

  get isAdmin(): boolean {
    if (this.loggedInUserRole === 'Admin') {
      return true;
    } else {
      return false;
    }
  }

  get isUserAnonymousLoggedIn(): boolean {
    return (this.authState !== null) ? this.authState.isAnonymous : false
  }

  get currentUserId(): string {
    
    return (this.authState !== null) ? this.authState.uid : ''
  }

  
  get currentUserName(): string {
    return this.authState['email']
  }
  
  
  
  get currentUser(): any {
    return (this.authState !== null) ? this.authState : null;
  }

  get isUserEmailLoggedIn(): boolean {
    if ((this.authState !== null) && (!this.isUserAnonymousLoggedIn)) {
      return true
    } else {
      return false
    }
  }


  editUser() {
    // Sets user data to firestore on login
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${this.editUser_ID}`);
    if (this.editUser_role === 'Advertiser') {
      const data: User = {
        uid: this.editUser_ID,
        email: this.editUser_newEmail,
        userName: this.editUser_username,
        user_type: this.editUser_role,
        client: this.editUser_client,
        roles: {
          advertiser: true
        },
        monthly_quota: this.monthly_quota,
        used_quota: 0,
        topUpCredits:0
      }
      return userRef.set(data, { merge: true })
    }


    if (this.editUser_role === 'Admin') {
      const data: User = {
        uid: this.editUser_ID,
        email: this.editUser_newEmail,
        userName: this.editUser_username,
        user_type: this.editUser_role,
        client: this.editUser_client,
        roles: {
          admin: true
        },
        monthly_quota: this.monthly_quota,
        used_quota: 0,
        topUpCredits:0
      }
      return userRef.set(data, { merge: true })
    }


    if (this.editUser_role === 'Publisher') {
      const data: User = {
        uid: this.editUser_ID,
        email: this.editUser_newEmail,
        userName: this.editUser_username,
        user_type: this.editUser_role,
        client: this.editUser_client,
        roles: {
          publisher: true
        },
        monthly_quota: this.monthly_quota,
        used_quota: 0,
        topUpCredits:0
      }
      // console.log(userRef)
      return userRef.set(data, { merge: true })
    }
  }

  signUpWithEmail(email: string, password: string) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password)
      .then((user) => {
        this.authState = user
        this.updateUserData(user)
      })
      .catch(error => {
        // console.log(error)
        throw error
      });
  }

  loginWithEmail(email: string, password: string) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then((user) => {
        this.authState = user
        if (user.userName !== '' && user.password != '' ) { // {3}
      this.loggedIn.next(true);
      this.router.navigate(['/home']);
    }
        // this.updateUserData(user)
      })
      .catch(error => {
        // console.log(error)
        throw error
      });
  }

  signOut(): void {
    this.afAuth.auth.signOut();
    this.logout = true;
    if (this.logout) {
      this.router.navigate(['/login']);
    }
    // this.router.navigate(['/login']);
  }


  private updateUserData(user) {
    // Sets user data to firestore on login
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);



    if (this.roleuser === 'Advertiser') {
      // console.log(this.roleuser)


      const data: User = {
        uid: user.uid,
        email: user.email,
        userName: this.username_value,
        user_type: this.roleuser,
        client: this.client,
        roles: {
          advertiser: true
        },
        monthly_quota: this.monthly_quota,
        used_quota: 0,
        topUpCredits:0
      }
      return userRef.set(data, { merge: true })
    }


    if (this.roleuser === 'Admin') {

      // console.log(this.roleuser)

      const data: User = {
        uid: user.uid,
        email: user.email,
        userName: this.username_value,
        user_type: this.roleuser,
        client: this.client,
        roles: {
          admin: true
        },
        monthly_quota: this.monthly_quota,
        used_quota: 0,
        topUpCredits:0
      }
      return userRef.set(data, { merge: true })
    }


    if (this.roleuser === 'Publisher') {
      // console.log(this.roleuser)

      const data: User = {
        uid: user.uid,
        email: user.email,
        userName: this.username_value,
        user_type: this.roleuser,
        client: this.client,
        roles: {
          publisher: true
        },
        monthly_quota: this.monthly_quota,
        used_quota: 0,
        topUpCredits:0
      }
      return userRef.set(data, { merge: true })
    }



  }





}



// WEBPACK FOOTER //
// ./src/app/core/auth.service.ts